import { Row, Col } from "reactstrap";
import spinner from "../../../assets/spinner.svg";

type SpinnerProps = {
  loadingTitle?: string;
  loadingSubTitle?: string;
};
export const Spinner = (props: SpinnerProps) => {
  return (
    <>
      <Row>
        <Col className="spinner-container">
          <img
            className="spinner"
            src={spinner}
            alt="Page loading, please wait"
            tabIndex={0}
          />
        </Col>
      </Row>
      {props.loadingTitle && (
        <Row>
          <Col>
            <div className="spinner-text">{props.loadingTitle}</div>
          </Col>
        </Row>
      )}
      {props.loadingSubTitle && (
        <Row>
          <Col>
            <div className="spinner-text ">{props.loadingSubTitle}</div>
          </Col>
        </Row>
      )}
      <br />
    </>
  );
};
